import { useState } from "react";
import { mysteryShoppers } from "@/mocks/mysteryShoppers";
import { getBrandConfig } from "@/config/brand";

export default function MysteryShoppers() {
  const [showAll, setShowAll] = useState(false);
  const config = getBrandConfig().mysteryShoppers;

  const displayed = showAll ? mysteryShoppers : mysteryShoppers.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="section-title">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-user-star-line text-primary text-xl" />
              </div>
              {config.title}
            </h2>
            {config.subtitle && (
              <p className="text-sm text-slate-500 mt-1">{config.subtitle}</p>
            )}
          </div>
          {mysteryShoppers.length > 4 && (
            <button
              onClick={() => setShowAll(!showAll)}
              className="text-sm text-slate-500 hover:text-primary transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              {showAll ? "收起" : "查看全部"}
              <div className="w-4 h-4 flex items-center justify-center">
                {showAll ? (
                  <i className="ri-arrow-up-line" />
                ) : (
                  <i className="ri-arrow-right-line" />
                )}
              </div>
            </button>
          )}
        </div>

        {/* Shoppers Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {displayed.map((shopper) => {
            const badge = config.badgeMap[shopper.badge] || { label: "美學好手", color: "bg-rose-100 text-rose-700 border-rose-200" };
            return (
              <a
                key={shopper.id}
                href={`/authors/author-${shopper.id}`}
                className="group bg-white rounded-xl p-4 md:p-5 card-shadow hover:card-shadow-hover transition-all duration-300 text-center"
              >
                <div className="relative w-20 h-20 md:w-24 md:h-24 mx-auto mb-3 md:mb-4">
                  <img
                    loading="lazy"
                    src={shopper.avatar}
                    alt={shopper.name}
                    className="w-full h-full object-cover rounded-full border-2 border-slate-100"
                  />
                  <div className="absolute -bottom-1 -right-1 w-7 h-7 bg-white rounded-full flex items-center justify-center shadow-sm">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-verified-badge-fill text-primary text-sm" />
                    </div>
                  </div>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-slate-800 mb-0.5">
                  {shopper.name}
                </h3>
                <p className="text-xs text-slate-400 mb-2">{shopper.title}</p>

                {/* Badge */}
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium border mb-2 ${badge.color}`}>
                  {badge.label}
                </span>

                {/* Stats / Expertise */}
                {config.mode === "stats" ? (
                  <div className="flex items-center justify-center gap-3 text-xs text-slate-500 mb-1">
                    <span className="flex items-center gap-1">
                      <div className="w-3.5 h-3.5 flex items-center justify-center">
                        <i className="ri-article-line text-slate-400" />
                      </div>
                      參與 {shopper.reviewCount} 次評比
                    </span>
                  </div>
                ) : (
                  <>
                    <div className="flex items-center justify-center gap-3 text-xs text-slate-500 mb-1">
                      <span className="flex items-center gap-1">
                        <div className="w-3.5 h-3.5 flex items-center justify-center">
                          <i className="ri-article-line text-slate-400" />
                        </div>
                        {shopper.reviewCount} 篇評測
                      </span>
                    </div>
                    <p className="text-xs text-slate-400">
                      專長：{shopper.specialty}
                    </p>
                  </>
                )}
              </a>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center mt-8 md:mt-10">
          <a
            href="/join-us"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white font-medium rounded-full hover:bg-primary-dark transition-colors"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-user-add-line" />
            </div>
            {config.ctaLabel}
          </a>
        </div>
      </div>
    </section>
  );
}